import { toString as toString_1, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, tuple_type, bool_type, string_type, union_type, record_type, class_type, array_type, option_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Activity_$reflection, VesselModule_TimelineVessel_$reflection } from "../Shared/ApiDataTypes.js";
import { equals as equals_1, date, addMonths, create, now, year } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { parseDateIso8601, fromUtcToLocalDate, toUtcString, isBig as isBig_1, formatDateForUri } from "../Utils.js";
import { split, printf, toConsole, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { last, item, equalsWith, concat, tryFind, choose, unzip, append, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { value as value_155, unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { ActivityTemplate, ActivityTemplate_$reflection } from "../Timeline/Types.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { createObj, numberHash, int32ToString, defaultOf, uncurry2, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Vessels_fetchTimelineVessels, mapFetchError } from "../Promises.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { TimelineModule_timelineGroup, TimelineModule_timelineTooltip, TimelineModule_timelineOptions } from "../Fable.Vis.Timeline.js";
import moment from "moment";
import { Timeline } from "vis-timeline/standalone";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { createItem } from "../Timeline/API.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Skeleton, TableBody, IconButton, Checkbox, Link, TableHead, TableRow, TableSortLabel, Table, TableCell, Tab, Tabs, Button, Portal, Fab, Typography } from "@mui/material";
import { wrapTooltip } from "../ViewHelpers.js";
import ZoomOutMap from "@mui/icons-material/ZoomOutMap";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import { globalCtx } from "../Context.js";
import { HistoricState_CalculateFromDates, HistoricState_get_AllTypes, HistoricState__get_ColorCode, Role, Role__get_Identifier } from "../Shared/Shared.js";
import { empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { EditModal, AddModal } from "../ActivityModal.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { DateOnlyRangePicker } from "../Timeline/DateOnlyRangePicker.js";
import { vesselMultipleSelectAutocomplete } from "../Timeline/Helpers.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Int32.js";
import Edit from "@mui/icons-material/Edit";

class ActivityFilter extends Record {
    constructor(Page, Vessels, Start, End) {
        super();
        this.Page = Page;
        this.Vessels = Vessels;
        this.Start = Start;
        this.End = End;
    }
}

function ActivityFilter_$reflection() {
    return record_type("RouteActivity.ActivityFilter", [], ActivityFilter, () => [["Page", option_type(int32_type)], ["Vessels", array_type(VesselModule_TimelineVessel_$reflection())], ["Start", class_type("System.DateTime")], ["End", class_type("System.DateTime")]]);
}

function ActivityFilter_Default() {
    const currentYear = year(now()) | 0;
    return new ActivityFilter(0, [], create(currentYear, 1, 1), create(currentYear, 12, 31));
}

function ActivityFilter__ToUri(this$) {
    return ((("?" + (`start=${formatDateForUri(this$.Start)}`)) + (`&end=${formatDateForUri(this$.End)}`)) + ((this$.Vessels.length === 0) ? "" : (`&vessels=${join(",", map((x) => (`${x.Id}`), this$.Vessels))}`))) + defaultArg(map_1((p) => (`&page=${p}`), this$.Page), "");
}

class DisplayMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PaginatedTable", "Timeline"];
    }
}

function DisplayMode_$reflection() {
    return union_type("RouteActivity.DisplayMode", [], DisplayMode, () => [[], []]);
}

class Model extends Record {
    constructor(Activities, Vessels, Filter, Error$, CurrentTab, AddForm, LastPageReached, IsSuperAdmin, CanEdit, EditForm) {
        super();
        this.Activities = Activities;
        this.Vessels = Vessels;
        this.Filter = Filter;
        this.Error = Error$;
        this.CurrentTab = CurrentTab;
        this.AddForm = AddForm;
        this.LastPageReached = LastPageReached;
        this.IsSuperAdmin = IsSuperAdmin;
        this.CanEdit = CanEdit;
        this.EditForm = EditForm;
    }
}

function Model_$reflection() {
    return record_type("RouteActivity.Model", [], Model, () => [["Activities", array_type(Activity_$reflection())], ["Vessels", option_type(array_type(VesselModule_TimelineVessel_$reflection()))], ["Filter", ActivityFilter_$reflection()], ["Error", option_type(string_type)], ["CurrentTab", DisplayMode_$reflection()], ["AddForm", option_type(ActivityTemplate_$reflection())], ["LastPageReached", bool_type], ["IsSuperAdmin", bool_type], ["CanEdit", bool_type], ["EditForm", option_type(Activity_$reflection())]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ActivityResponse", "VesselsResponse", "UpdateFilter", "SetError", "SetCurrentTab", "AddActivity", "EditActivity", "DeleteActivity", "SetAddForm", "SetEditForm"];
    }
}

function Message_$reflection() {
    return union_type("RouteActivity.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(option_type(int32_type), array_type(Activity_$reflection())), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(option_type(int32_type), array_type(Activity_$reflection()))]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(VesselModule_TimelineVessel_$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", array_type(VesselModule_TimelineVessel_$reflection())]], [["ErrorValue", string_type]]])]], [["Item", ActivityFilter_$reflection()]], [["Item", option_type(string_type)]], [["Item", DisplayMode_$reflection()]], [["Item", Activity_$reflection()]], [["Item", Activity_$reflection()]], [["Item", int32_type]], [["Item", option_type(ActivityTemplate_$reflection())]], [["Item", option_type(Activity_$reflection())]]]);
}

function init(isSuperAdmin, isOperatorOrCompanyAdmin) {
    return new Model([], undefined, ActivityFilter_Default(), undefined, new DisplayMode(0, []), undefined, false, isSuperAdmin, isOperatorOrCompanyAdmin, undefined);
}

function update(model, msg) {
    let bind$0040;
    switch (msg.tag) {
        case 2:
            return new Model(model.Activities, model.Vessels, msg.fields[0], model.Error, model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
        case 3:
            return new Model(model.Activities, model.Vessels, model.Filter, msg.fields[0], model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
        case 4:
            return new Model(model.Activities, model.Vessels, model.Filter, model.Error, msg.fields[0], model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
        case 0: {
            const x_4 = msg.fields[0];
            if (x_4.tag === 0) {
                const y_1 = x_4.fields[0][1];
                const page = x_4.fields[0][0];
                return new Model((equals(page, undefined) ? true : equals(page, 0)) ? y_1 : append(model.Activities, y_1), model.Vessels, (bind$0040 = model.Filter, new ActivityFilter(page, bind$0040.Vessels, bind$0040.Start, bind$0040.End)), model.Error, model.CurrentTab, model.AddForm, y_1.length < 25, model.IsSuperAdmin, model.CanEdit, model.EditForm);
            }
            else {
                return new Model(model.Activities, model.Vessels, model.Filter, x_4.fields[0], model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
            }
        }
        case 5:
            return new Model(append([msg.fields[0]], model.Activities), model.Vessels, model.Filter, model.Error, model.CurrentTab, undefined, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
        case 6: {
            const x_6 = msg.fields[0];
            return new Model(map((y_2) => {
                if (x_6.Id === y_2.Id) {
                    return x_6;
                }
                else {
                    return y_2;
                }
            }, model.Activities), model.Vessels, model.Filter, model.Error, model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, undefined);
        }
        case 7:
            return new Model(model.Activities.filter((x_7) => (x_7.Id !== msg.fields[0])), model.Vessels, model.Filter, model.Error, model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, undefined);
        case 8:
            return new Model(model.Activities, model.Vessels, model.Filter, model.Error, model.CurrentTab, msg.fields[0], model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
        case 9:
            return new Model(model.Activities, model.Vessels, model.Filter, model.Error, model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, msg.fields[0]);
        default: {
            const x = msg.fields[0];
            if (x.tag === 1) {
                return new Model(model.Activities, model.Vessels, model.Filter, x.fields[0], model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
            }
            else {
                return new Model(model.Activities, x.fields[0], model.Filter, model.Error, model.CurrentTab, model.AddForm, model.LastPageReached, model.IsSuperAdmin, model.CanEdit, model.EditForm);
            }
        }
    }
}

function fetchActivities(routeId, filter, callback) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const url = (`/api/activity/route/${routeId}`) + ActivityFilter__ToUri(filter);
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(tuple_type(option_type(int32_type), array_type(Activity_$reflection())), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(tuple_type(option_type(int32_type), array_type(Activity_$reflection())), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then(mapFetchError))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

/**
 * React element that renders a timeline of the given activities.
 * This component mounts a div and hydrates it to a timeline.
 * Since this is an async render, we want to avoid rehydrating if possible
 * To do this we use effects to refetch activities when the given filters change.
 */
export function TimelineComponent(timelineComponentInputProps) {
    let elems_1, elems, props_1, props_4, props_7;
    const canEdit = timelineComponentInputProps.canEdit;
    const onActivityEdit = timelineComponentInputProps.onActivityEdit;
    const onActivityAdd = timelineComponentInputProps.onActivityAdd;
    const vessels = timelineComponentInputProps.vessels;
    const activities = timelineComponentInputProps.activities;
    const maxDate = timelineComponentInputProps.maxDate;
    const minDate = timelineComponentInputProps.minDate;
    let timeline;
    const initialValue = defaultOf();
    timeline = (reactApi.useRef(initialValue));
    useEffectOnce(() => {
        const timelineComponent = document.getElementById("timeline");
        const o = TimelineModule_timelineOptions([["zoomMin", 36000000], ["min", addMonths(minDate, -3)], ["max", addMonths(maxDate, 3)], ["groupOrder", "title"], ["tooltip", TimelineModule_timelineTooltip([["followMouse", true], ["delay", 200]])], ["zoomKey", "ctrlKey"], ["selectable", false], ["editable", false], ["xss", {
            disabled: false,
            filterOptions: {
                whiteList: {
                    a: ["href", "style"],
                    button: ["class", "tabindex", "title", "type"],
                    div: "class",
                    p: "class",
                    path: "d",
                    span: ["style", "class"],
                    svg: ["class", "focusable", "viewBox", "aria-hidden"],
                },
            },
        }], ["maxHeight", "80vh"], ["verticalScroll", true], ["orientation", "top"]]);
        o.moment = ((x_4) => {
            const m = new moment(x_4);
            return m.locale("nb");
        });
        const t = new Timeline(timelineComponent, new Array(0), undefined, o);
        timeline.current = t;
    });
    const dependencies = [activities];
    reactApi.useEffect(() => {
        let patternInput;
        const tupledArg_1 = unzip(map((tupledArg) => {
            const vessel = tupledArg[0];
            const groupId = `v-${vessel.Id}`;
            return [TimelineModule_timelineGroup([["id", groupId], ["content", `<a href="${RouterModule_encodeParts(ofArray(["vessels", int32ToString(vessel.Id), "activities"]), 1)}">${vessel.Name}</a> ${!canEdit ? "" : "<button class=\"timeline-add-button\" tabindex=\"0\" type=\"button\" title=\"Legg til aktivitet\" style=\"box-shadow: none;\">\n                    <span>+</span>\n                   </button>"}`], ["title", vessel.Name]]), map((activity) => createItem(groupId, maxDate, activity), tupledArg[1])];
        }, choose((x_2) => map_1((y_2) => [y_2, x_2[1]], tryFind((y_1) => (y_1.Id === x_2[0]), vessels)), Array_groupBy((x) => x.VesselId, activities, {
            Equals: (x_1, y) => (x_1 === y),
            GetHashCode: numberHash,
        }))));
        patternInput = [tupledArg_1[0], concat(tupledArg_1[1])];
        timeline.current.setItems(patternInput[1]);
        timeline.current.setGroups(patternInput[0]);
        timeline.current.fit();
        timeline.current.on('doubleClick', ((ev) => {
            if (!canEdit) {
            }
            else {
                const matchValue = ev.what;
                let matchResult;
                if (matchValue != null) {
                    switch (matchValue) {
                        case "item": {
                            if (ev.item != null) {
                                matchResult = 0;
                            }
                            else {
                                matchResult = 2;
                            }
                            break;
                        }
                        case "background": {
                            matchResult = 1;
                            break;
                        }
                        default:
                            matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        onActivityEdit(value_155(ev.item));
                        break;
                    }
                    case 1: {
                        const matchValue_1 = ev.group;
                        let matchResult_1, g_1;
                        if (matchValue_1 != null) {
                            if (typeof value_155(matchValue_1) === "string") {
                                matchResult_1 = 0;
                                g_1 = value_155(matchValue_1);
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0: {
                                onActivityAdd([g_1, ev.time]);
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                        break;
                    }
                    case 2: {
                        break;
                    }
                }
            }
        }));
        timeline.current.on('click', ((ev_1) => {
            const matchValue_2 = ev_1.what;
            let matchResult_2;
            if (matchValue_2 != null) {
                if (matchValue_2 === "group-label") {
                    matchResult_2 = 0;
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0: {
                    if (ev_1.event.target.localName !== "a") {
                        const matchValue_3 = ev_1.group;
                        let matchResult_3, g_3;
                        if (matchValue_3 != null) {
                            if (typeof value_155(matchValue_3) === "string") {
                                matchResult_3 = 0;
                                g_3 = value_155(matchValue_3);
                            }
                            else {
                                matchResult_3 = 1;
                            }
                        }
                        else {
                            matchResult_3 = 1;
                        }
                        switch (matchResult_3) {
                            case 0: {
                                onActivityAdd([g_3, date(now())]);
                                break;
                            }
                            case 1: {
                                break;
                            }
                        }
                    }
                    break;
                }
                case 1: {
                    break;
                }
            }
        }));
    }, dependencies);
    const dependencies_2 = [minDate, maxDate];
    reactApi.useEffect(() => {
        const options = TimelineModule_timelineOptions([["min", addMonths(minDate, -3)], ["max", addMonths(maxDate, 3)]]);
        timeline.current.setOptions(options);
        toConsole(printf("min max date changed"));
    }, dependencies_2);
    const children_3 = ofArray([MuiHelpers_createElement(Typography, [["children", `Viser: ${activities.length} aktiviteter`]]), createElement("div", createObj(ofArray([["id", "timeline"], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        position: "absolute",
        zIndex: 1000,
        right: 0,
        top: 0,
        margin: 5,
        display: "flex",
        gap: 5 + "px ",
    }], ["aria-label", "timeline-menu"], (elems = [wrapTooltip("Zoom til å vise alle", MuiHelpers_createElement(Fab, [["size", "small"], ["color", "primary"], ["onClick", (_arg_2) => {
        timeline.current.fit();
    }], ["children", (props_1 = {}, react.createElement(ZoomOutMap, props_1))]])), wrapTooltip("Zoom inn", MuiHelpers_createElement(Fab, [["size", "small"], ["color", "primary"], ["onClick", (_arg_3) => {
        timeline.current.zoomIn(1);
    }], ["children", (props_4 = {}, react.createElement(Add, props_4))]])), wrapTooltip("Zoom ut", MuiHelpers_createElement(Fab, [["size", "small"], ["color", "primary"], ["onClick", (_arg_4) => {
        timeline.current.zoomOut(1);
    }], ["children", (props_7 = {}, react.createElement(Remove, props_7))]]))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))]);
    return createElement("div", {
        children: reactApi.Children.toArray(Array.from(children_3)),
    });
}

/**
 * React component used to fetch and render a list of vessels based on filter.
 */
export function RouteActivities(routeActivitiesInputProps) {
    let elems_19;
    const routeId = routeActivitiesInputProps.routeId;
    const ctx = reactApi.useContext(globalCtx);
    let patternInput;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        patternInput = [s.IsSuperAdmin, s.Roles.some((r) => {
            if (r.RoleId === Role__get_Identifier(new Role(3, []))) {
                return true;
            }
            else {
                return r.RoleId === Role__get_Identifier(new Role(6, []));
            }
        })];
    }
    else {
        patternInput = [false, false];
    }
    const initialModel = init(patternInput[0], patternInput[1]);
    const patternInput_1 = reactApi.useReducer(update, initialModel);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const isBig = isBig_1(ctx.Responsive);
    useEffectOnce(() => {
        fetchActivities(routeId, initialModel.Filter, (arg_2) => {
            dispatch(new Message(0, [arg_2]));
        });
        Vessels_fetchTimelineVessels((arg_3) => {
            dispatch(new Message(1, [arg_3]));
        });
    });
    const updateAndFetchFilter = (newFilter) => {
        fetchActivities(routeId, newFilter, (arg_4) => {
            dispatch(new Message(0, [arg_4]));
        });
        dispatch(new Message(2, [newFilter]));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
        paddingTop: 8,
        maxWidth: ("calc(" + "100vw - 20px") + ")",
        flexGrow: 1,
    }], (elems_19 = toList(delay(() => {
        let children_7;
        const matchValue_2 = model_1.Vessels;
        if (matchValue_2 != null) {
            const vessels_2 = matchValue_2;
            return append_1(singleton((children_7 = toList(delay(() => {
                let matchValue_3, activity_1;
                return append_1((matchValue_3 = model_1.AddForm, (matchValue_3 != null) ? ((activity_1 = matchValue_3, singleton(AddModal(activity_1.VesselId, routeId, toUtcString(activity_1.Time), (_arg_5) => {
                    if (_arg_5 == null) {
                        dispatch(new Message(8, [undefined]));
                    }
                    else {
                        dispatch(new Message(5, [_arg_5]));
                    }
                }, vessels_2, undefined)))) : singleton(defaultOf_1())), delay(() => {
                    const matchValue_4 = model_1.EditForm;
                    if (matchValue_4 != null) {
                        return singleton(EditModal(matchValue_4, (_arg_6) => {
                            if (_arg_6 == null) {
                                dispatch(new Message(9, [undefined]));
                            }
                            else {
                                dispatch(new Message(6, [_arg_6]));
                            }
                        }, (arg_12) => {
                            dispatch(new Message(7, [arg_12]));
                        }, vessels_2, undefined));
                    }
                    else {
                        return empty_1();
                    }
                }));
            })), MuiHelpers_createElement(Portal, [["children", reactApi.Children.toArray(Array.from(children_7))]]))), delay(() => {
                let elems_16;
                return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5 + "rem",
                    width: "fit-content",
                }], (elems_16 = toList(delay(() => {
                    let elems_15;
                    const resetPage = map_1((_arg_3) => 0, model_1.Filter.Page);
                    return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                        width: 250,
                    }], (elems_15 = [createElement(DateOnlyRangePicker, {
                        label: "Fra dato - Til dato",
                        value: [model_1.Filter.Start, model_1.Filter.End],
                        setValue: (x_8) => {
                            if (!equalsWith(equals_1, x_8, defaultOf()) && (x_8.length === 2)) {
                                const y_2 = item(1, x_8);
                                updateAndFetchFilter(new ActivityFilter(resetPage, model_1.Filter.Vessels, item(0, x_8), date(y_2)));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))), delay(() => append_1(singleton(vesselMultipleSelectAutocomplete("Fartøy", vessels_2, isBig, model_1.Filter.Vessels, (x_11) => {
                        let bind$0040_2;
                        updateAndFetchFilter((bind$0040_2 = model_1.Filter, new ActivityFilter(bind$0040_2.Page, x_11, bind$0040_2.Start, bind$0040_2.End)));
                    }, false)), delay(() => {
                        let props_20;
                        return (model_1.IsSuperAdmin ? true : model_1.CanEdit) ? singleton(MuiHelpers_createElement(Button, [["style", {
                            width: "max-content",
                            height: 40,
                        }], ["size", "medium"], ["startIcon", (props_20 = {}, react.createElement(Add, props_20))], ["children", "Legg til aktivitet"], ["onClick", (_arg_4) => {
                            dispatch(new Message(8, [new ActivityTemplate(routeId, undefined, date(now()))]));
                        }]])) : empty_1();
                    }))));
                })), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))), delay(() => {
                    let elements_8;
                    return append_1(singleton(MuiHelpers_createElement(Tabs, [["value", equals(model_1.CurrentTab, new DisplayMode(0, [])) ? 0 : 1], ["textColor", "primary"], ["onChange", (_arg_7, v) => {
                        let matchValue_5, bind$0040_4, bind$0040_3;
                        const newTab = (v === 0) ? (new DisplayMode(0, [])) : (new DisplayMode(1, []));
                        updateAndFetchFilter((matchValue_5 = model_1.Filter.Page, (newTab.tag === 1) ? ((matchValue_5 == null) ? model_1.Filter : ((bind$0040_4 = model_1.Filter, new ActivityFilter(undefined, bind$0040_4.Vessels, bind$0040_4.Start, bind$0040_4.End)))) : ((matchValue_5 != null) ? model_1.Filter : ((bind$0040_3 = model_1.Filter, new ActivityFilter(0, bind$0040_3.Vessels, bind$0040_3.Start, bind$0040_3.End))))));
                        dispatch(new Message(4, [newTab]));
                    }], ["indicatorColor", "primary"], (elements_8 = [MuiHelpers_createElement(Tab, [["label", "Tabell"]]), MuiHelpers_createElement(Tab, [["label", "Tidslinje"]])], ["children", reactApi.Children.toArray(Array.from(elements_8))])])), delay(() => {
                        let renderActivityStatus, headerCell, td$0027, xs_5, elems_1, elems_14, elements_6, children_2, children_1, elems_6, children_5, x_7, children, elems_2;
                        return (model_1.CurrentTab.tag === 1) ? singleton(createElement(TimelineComponent, {
                            minDate: model_1.Filter.Start,
                            maxDate: model_1.Filter.End,
                            activities: model_1.Activities,
                            vessels: vessels_2,
                            onActivityAdd: (tupledArg) => {
                                dispatch(new Message(8, [new ActivityTemplate(routeId, (() => {
                                    try {
                                        return parse(last(split(tupledArg[0], ["-"], undefined, 0)), 511, false, 32);
                                    }
                                    catch (matchValue_1) {
                                        return undefined;
                                    }
                                })(), tupledArg[1])]));
                            },
                            onActivityEdit: (y_3) => {
                                dispatch(new Message(9, [tryFind((x_16) => (x_16.Id === y_3), model_1.Activities)]));
                            },
                            canEdit: model_1.IsSuperAdmin ? true : model_1.CanEdit,
                        })) : singleton((renderActivityStatus = ((includeText, x) => {
                            const xs_1 = toList(delay(() => {
                                let x_1;
                                return append_1(singleton((x_1 = createElement("span", {
                                    style: {
                                        marginRight: 5,
                                        display: "inline-block",
                                        width: 1 + "em",
                                        height: 1 + "em",
                                        backgroundColor: HistoricState__get_ColorCode(x),
                                        borderRadius: 50 + "%",
                                    },
                                }), wrapTooltip(toString_1(x), x_1))), delay(() => (includeText ? singleton(toString_1(x)) : empty_1())));
                            }));
                            return react.createElement(react.Fragment, {}, ...xs_1);
                        }), (headerCell = ((title_1) => MuiHelpers_createElement(TableCell, [["style", {
                            paddingRight: 6,
                        }], ["variant", "head"], ["children", title_1]])), (td$0027 = ((c) => MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", reactApi.Children.toArray(Array.from(c))]])), (xs_5 = [createElement("div", createObj(ofArray([["style", {
                            marginLeft: "auto",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 5 + "px ",
                        }], (elems_1 = [map((x_2) => {
                            let elems;
                            return createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                fontSize: 1 + "rem",
                            }], (elems = [renderActivityStatus(true, x_2)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
                        }, HistoricState_get_AllTypes())], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
                            overflowX: "auto",
                        }], (elems_14 = [MuiHelpers_createElement(Table, [["size", "small"], (elements_6 = [(children_2 = singleton_1((children_1 = ofArray([headerCell("Id"), headerCell("Fartøy"), MuiHelpers_createElement(TableCell, [["style", {
                            paddingRight: 6,
                        }], ["sortDirection", "desc"], ["variant", "head"], (elems_6 = [MuiHelpers_createElement(TableSortLabel, [["active", true], ["direction", "desc"], ["disabled", true], ["children", reactApi.Children.toArray(["Fra dato"])]])], ["children", reactApi.Children.toArray(Array.from(elems_6))])]), headerCell("Til dato"), headerCell("Status"), headerCell("Bekreftet"), headerCell("Beskrivelse"), MuiHelpers_createElement(TableCell, [["style", {
                            padding: 0,
                        }], ["variant", "head"], ["children", ""]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_5 = singleton_1((x_7 = map((activity) => {
                            let elems_10, elems_9, props_13;
                            const vessel = tryFind((x_4) => (x_4.Id === activity.VesselId), vessels_2);
                            const children_4 = ofArray([td$0027([int32ToString(activity.Id)]), td$0027([defaultArg(map_1((x_5) => MuiHelpers_createElement(Link, [["style", {
                                cursor: "pointer",
                            }], ["children", x_5.Name], ["href", RouterModule_encodeParts(ofArray(["vessels", int32ToString(x_5.Id), "info"]), 1)]]), vessel), MuiHelpers_createElement(Typography, [["children", "Ukjent"]]))]), td$0027([fromUtcToLocalDate(activity.FromDate)]), td$0027([defaultArg(map_1(fromUtcToLocalDate, activity.ToDate), "-")]), td$0027([renderActivityStatus(false, HistoricState_CalculateFromDates(parseDateIso8601(activity.FromDate), map_1(parseDateIso8601, activity.ToDate)))]), td$0027([MuiHelpers_createElement(Checkbox, [["disabled", true], ["checked", activity.Confirmed]])]), td$0027([activity.InfoText]), MuiHelpers_createElement(TableCell, [["style", {
                                padding: 0,
                            }], ["size", "small"], ["variant", "body"], (elems_10 = [wrapTooltip("Rediger aktivitet", MuiHelpers_createElement(IconButton, [["onClick", (_arg_2) => {
                                dispatch(new Message(9, [activity]));
                            }], (elems_9 = [(props_13 = {}, react.createElement(Edit, props_13))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])]);
                            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_4))]]);
                        }, model_1.Activities), (((model_1.Activities.length % 25) === 0) && !model_1.LastPageReached) ? append(x_7, [(children = singleton_1(MuiHelpers_createElement(TableCell, [["colSpan", 7], (elems_2 = [MuiHelpers_createElement(Button, [["children", "Last flere"], ["onClick", (_arg_1) => {
                            let bind$0040;
                            updateAndFetchFilter((bind$0040 = model_1.Filter, new ActivityFilter(map_1((y) => (1 + y), model_1.Filter.Page), bind$0040.Vessels, bind$0040.Start, bind$0040.End)));
                        }]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))]) : x_7)), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], react.createElement(react.Fragment, {}, ...xs_5))))));
                    }));
                }));
            }));
        }
        else {
            return singleton(MuiHelpers_createElement(Skeleton, [["animation", "pulse"], ["variant", "rectangular"], ["width", 100 + "%"], ["height", 400]]));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_19))])])));
}

//# sourceMappingURL=RouteActivity.js.map
